import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NaModel } from 'src/app/shared/models/simple-types/na.model';
import { APICONSTANTS } from '../../constants/api-constants';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HostnameService } from '../basic/hostname.service';
import { GenericLibelleService } from '../basic/generic-libelle.service';
import { NTHDestination } from '../../constants/flag';

@Injectable()
export class NaService extends GenericLibelleService<NaModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTENA, hostnameService);
  }

  getFromCa1(idSociete: any, idCa1: number): Observable<NaModel[]> {
    // tslint:disable-next-line
    return this.http.get<NaModel[]>(APICONSTANTS.URLAPI.value + this.route + 'GetFromCa1?idSociete=' + idSociete + '&idCa1=' + idCa1)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }

  getFromDestinationCategorie(idActivite: any, idCategorie: number, destination: NTHDestination): Observable<NaModel> {
    // tslint:disable-next-line
    return this.http.get<NaModel>(APICONSTANTS.URLAPI.value + this.route + 'getFromDestinationCategorie?idActivite=' + idActivite + '&idCategorie=' + idCategorie + '&destination=' + destination)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }
  
}
